import { TransactionFilters } from '../../../types';

export const TRANSACTION_BUYER_SCOPES = ['user', 'agent', 'shop', 'super_agent'] as const;

export type TransactionBuyerScope = (typeof TRANSACTION_BUYER_SCOPES)[number];

export function parseBuyerScopeFromUrl(raw: string | null): TransactionBuyerScope {
  if (raw && TRANSACTION_BUYER_SCOPES.includes(raw as TransactionBuyerScope)) {
    return raw as TransactionBuyerScope;
  }
  return 'user';
}

export function buildUrlSearchParams(
  buyerScope?: TransactionFilters['buyerScope'],
  search?: string,
): URLSearchParams {
  const next = new URLSearchParams();
  const scope = buyerScope || 'user';
  const trimmedSearch = search?.trim() || '';
  if (scope !== 'user') {
    next.set('scope', scope);
  }
  if (trimmedSearch) {
    next.set('search', trimmedSearch);
  }
  return next;
}

export function buildTransactionsListSearch(
  opts: { buyerScope?: TransactionFilters['buyerScope']; search?: string } = {},
): string {
  const qs = buildUrlSearchParams(opts.buyerScope, opts.search).toString();
  return qs ? `?${qs}` : '';
}

export function transactionsListPath(
  opts: { buyerScope?: TransactionFilters['buyerScope']; search?: string } = {},
): string {
  return `/transactions${buildTransactionsListSearch(opts)}`;
}
